<template lang="jade" src="./target.jade"></template>

<script>
  export default {
    data () {
      return {
        animated_headline: "https://s3-us-west-1.amazonaws.com/db13/1440/hdr.svg",
        title: 'I Deliver your content',
        copy: 'Is it even worth asking if adaptability is survivability? Streaming! Upconverting! Real-time! With flexibility and openness as our God, there will always be light at the end of the tunnel. Open technology illuminates the path. Optimal bandwidth utilization, a single stream of perfection, the universal solution. Passion should never be barred from proliferation. HDR. Historic Double Rainbow? High Dynamic Range! Access limited only by the driving purity of…',
        lastword: 'DESIRE',
        video: 'https://s3-us-west-1.amazonaws.com/db13/1440/ce-distributors.mp4',
        back_link: '/content-owners',
        forward_link: '/ce-manufacturers',
        back_img: 'imgs/icons/back-arrow.svg',
        forward_img: 'imgs/icons/forward-arrow.svg',
        back: 'imgs/icons/back-arrow.svg',
        vTransparency: {
          opacity: '0.3'
        }
      }
    }
  }
</script>

<style lang="sass?indentedSyntax" scoped>

  @import "../../_sass/utilities/_utilities.sass"

  h1,
  span.beleive
    color: $lime!important

</style>


/** WEBPACK FOOTER **
 ** content-distributors.vue?afa7955e
 **/